/* globals IntersectionObserver */

const sections = document.querySelectorAll('.js-section')
const links = document.querySelectorAll('.js-navigation-link')

if (sections.length && links.length && global.IntersectionObserver) {
  // Holder variable for IntersectionObserver threshold
  let threshold = []

  // Create threshold (adjust this ▼)
  for (let i = 0; i <= 1.0; i += 0.1) {
    threshold.push(i)
  }

  // Holder variables for the section ratios
  let sectionRatios = {}

  const observer = new IntersectionObserver(entries => {
    // Populate global object which holds ratio values for each section,
    // even those that didn't get called in this callback
    entries.forEach(entry => {
      sectionRatios[entry.target.id] = {
        name: entry.target.id,
        ratio: entry.intersectionRatio
      }
    })

    // Convert object into array so we can use array sorting functionality
    let ratios = Object.values(sectionRatios)
    ratios.sort((a, b) => {
      return b.ratio - a.ratio
    })

    // Holder variable for the current link element
    let link

    for (let i = 0; i < links.length; i++) {
      // Clear active state for all links
      links[i].classList.remove('is-active')

      // Set link element if current link is target
      if (links[i].hash.substr(1) === ratios[0].name) {
        link = links[i]
      }
    }

    // Set active state if link is set
    if (link) {
      link.classList.add('is-active')
    }
  }, { threshold })

  // Observe all sections
  for (let i = 0; i < sections.length; i++) {
    observer.observe(sections[i])
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/highlight.js